import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Loader from '../shared/loader';
import stringHelpers from '../../utilities/stringHelpers';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterDisplay } from '../shared/appliedFilterDisplay';
import { ContraventionsFiltersModal } from './contraventionsFiltersModal';

function Contraventions(props) {
    const [contraventions, setContraventions] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [search, setSearch] = useState(null);
    const [status, setStatus] = useState(null);
    const [type, setType] = useState(null);
    const [dvlaCode, setDvlaCode] = useState(null);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const getContraventions = function () {
        setIsLoading(true)
        Api.getContraventions(
            (data) => { setContraventions(data); setIsLoading(false) },
            (error) => { console.log(error); setContraventions(null); setIsLoading(false) },
            props.organisationId,
            props.token
        )
    }
    const clearFilters = function () {
        setDvlaCode(null);
        setStatus(null);
        setType(null);
        setAppliedFilters(null);
        setShowFilterPills(false);
    }
    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Type":
                setType(null)
                break
            case "DVLA Code":
                setDvlaCode(null)
                break
            case "Status":
                setStatus(null)
                break
            default:
                break
        }
    }
    useEffect(() => {
        getContraventions()
    }, [])
    var addNewUrl = "/organisation/" + props.organisationId + "/contravention";
    return (
        <>
            {isLoading && <Loader />}{!isLoading && contraventions && contraventions !== null && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Contraventions</h5>
                                        </div>
                                        <div className="col-auto d-flex align-items-center ml-auto text-right pl-0">
                                            <div className='mr-2'>
                                                <SearchBarWithDebounce
                                                    onSearchQueryChange={query => setSearch(query)}
                                                />
                                            </div>
                                            <div className='mr-2'>
                                                <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                            </div>
                                            <Link className="btn btn-success btn-sm mr-1 ml-1 nowrap" to={addNewUrl}><i className="fas fa-plus"></i> Add</Link>
                                        </div>
                                    </div>
                                </div>
                                {
                                    showFilterPills && appliedFilters &&
                                    <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                        {
                                            Object.entries(appliedFilters).map(
                                                ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                                && <div className="mr-2" key={label}>
                                                    <AppliedFilterDisplay
                                                        label={label}
                                                        onTextClick={() => setShowFiltersModal(true)}
                                                        onCloseClick={closedLabel => {
                                                            clearFilterByLabel(closedLabel)
                                                            setAppliedFilters(prevState => {
                                                                const updatedFilters = { ...prevState }
                                                                updatedFilters[closedLabel] = null
                                                                const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                                return hasRemainingFilters ? updatedFilters : null
                                                            })
                                                        }}
                                                        value={value}
                                                    />
                                                </div>
                                            )
                                        }
                                        {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                                    </div>
                                }
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th>Contravention</th>
                                            <th>DVLA Code</th>
                                            <th>Type</th>
                                            <th className="text-center">Appeal Reply</th>
                                            <th className="text-center">Status</th>
                                            <th className="text-right">Reduced Charge Amount</th>
                                            <th className="text-right">Reduced Charge Days</th>
                                            <th className="text-right">Full Charge Amount</th>
                                            <th className="text-right">Full Charge Days</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contraventions.filter(function(contravention){
                                            var description = new String(contravention.name).toLowerCase();
                                            var itemDvlaCode = new String(contravention.dvlaCode).toLowerCase();
                                            var itemType = new String(Enums.ContraventionTypes[contravention.contraventionType]).toLowerCase();

                                            return((type === null || type === contravention.contraventionType) && (status == null || status === contravention.isActive) && (dvlaCode == null || dvlaCode === contravention.dvlaCode) && (search === null || description.search(search.toLowerCase()) !== -1 || itemDvlaCode.search(search.toLowerCase()) !== -1 || itemType.search(search.toLowerCase()) !== -1))
                                        }).map((contravention) => {
                                            var url = "/organisation/" + props.organisationId + "/contravention/" + contravention.id;
                                            var appealReply = false;
                                            if(contravention.appealReply !== "" || contravention.appealReply !== null){
                                                appealReply = true;
                                            }
                                            return (
                                                <tr>
                                                    <td><Link to={url}><h6 className="mb-0">{contravention.name}</h6></Link></td>
                                                        <td>{contravention.dvlaCode}</td>
                                                        <td>{Enums.ContraventionTypes[contravention.contraventionType]}</td>
                                                        <td className="text-center">{appealReply && <><i className="fas fa-check text-success"></i></>}{!appealReply && <><i className="fas fa-times text-danger"></i></>}</td>
                                                        <td className="text-center">{contravention.isActive && <><i className="fas fa-check text-success"></i></>}{!contravention.isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                        <td className="text-right">{stringHelpers.formatDecimal(contravention.reducedChargeAmount, 2, "£")}</td>
                                                        <td className="text-right">{stringHelpers.formatDecimal(contravention.reducedChargeDays, 0)}</td>
                                                        <td className="text-right">{stringHelpers.formatDecimal(contravention.fullChargeAmount, 2, "£")}</td>
                                                        <td className="text-right">{stringHelpers.formatDecimal(contravention.fullChargeDays, 0)}</td>
                                                </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showFiltersModal &&
                    <ContraventionsFiltersModal
                        showModal={showFiltersModal}
                        handleClose={() => setShowFiltersModal(false)}
                        handleConfirm={(draftFilters) => {
                            setType(draftFilters.type)
                            setDvlaCode(draftFilters.dvlaCode)
                            setStatus(draftFilters.status)
                            setAppliedFilters(draftFilters.appliedFilters)
                            setShowFilterPills(true)
                            setShowFiltersModal(false)
                        }}
                        initialType={type}
                        initialDvlaCode={dvlaCode}
                        initialStatus={status}
                        initialAppliedFilters={appliedFilters}
                        key="contraventions-filters-modal"
                    />
                }
            </>}
        </>
    )
}
export default Contraventions;